import * as React from "react";
import classNames from "classnames";
import { FormItemProps } from "antd/lib/form/FormItem";
import { ColProps } from "antd/lib/grid";
import { Form } from "antd";

const FormItem = Form.Item;
export interface CustomFormItemProps extends FormItemProps {
  label?: string | React.ReactNode;
  style?: React.CSSProperties;
  fullWidth?: boolean;
  className?: string;
  colon?: boolean;
  wrapperColExt?: ColProps;
  labelColExt?: ColProps;
}

export const CustomFormItem: React.FunctionComponent<CustomFormItemProps> = ({
  fullWidth,
  children,
  className,
  colon = false,
  labelAlign = "left",
  wrapperColExt = {},
  labelColExt = {},
  ...rest
}) => {
  const wrapperColProps = {
    lg: { span: 24 },
    xl: { span: fullWidth ? 24 : 17 },
    ...wrapperColExt,
  };
  const labelColProps = {
    lg: { span: 24 },
    xl: { span: fullWidth ? 24 : 6 },
    ...labelColExt,
  };
  const formClassNames = classNames("custom-form-item", className);

  return (
    <FormItem
      colon={colon}
      wrapperCol={wrapperColProps}
      labelCol={labelColProps}
      className={formClassNames}
      labelAlign={labelAlign}
      {...rest}
    >
      <>{children}</>
    </FormItem>
  );
};
